import React from "react";

import Icons from "../../../components/icons-helper";

import { theme } from "../../../styles/theme";
import * as S from "./styles";

import { useAuthGlobal } from "../../../../contexts/auth-context/auth-context";
import { NavigateCard } from "../../../components/cards";

interface IProps {
  count: number | undefined;
}

const HomeAdminTemplate: React.FC<IProps> = ({ count }) => {
  const { user } = useAuthGlobal();
  return (
    <S.Container>
      <S.Title>
        Olá {user?.name}, seja bem vindo! <hr />
      </S.Title>
      <S.Cards>
        <S.NewUsersCard>
          <Icons
            name="new-user"
            width={130}
            height={130}
            color={theme.colors.white}
          />
          <p>
            Você tem{" "}
            <span>
              {` ${Number(count || 0)
                .toString()
                .padStart(2, "0")} `}{" "}
            </span>
            novos usuários
          </p>
        </S.NewUsersCard>
        <NavigateCard
          to="/admin/solicitations"
          title="Ver novos usuários"
          icon="user"
        >
          Novos usuários
        </NavigateCard>
        <NavigateCard
          to="/admin/developers"
          title="Ver todos usuários"
          icon="users"
        >
          Todos usuários
        </NavigateCard>
      </S.Cards>
    </S.Container>
  );
};
export default HomeAdminTemplate;
